"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBillingAddress = exports.toggle = exports.payload = exports.update = exports.createReducer = void 0;
const ramda_1 = require("ramda");
function createReducer({ initialState, actions }) {
    return function reducer(state = initialState, action) {
        if (actions.hasOwnProperty(action.type)) {
            const handler = actions[action.type];
            return handler instanceof Function
                ? handler((0, ramda_1.clone)(state), action.payload)
                : (0, ramda_1.clone)(handler);
        }
        return state;
    };
}
exports.createReducer = createReducer;
const update = (propertyName) => (state, property) => (Object.assign(Object.assign({}, state), { [propertyName]: property }));
exports.update = update;
exports.payload = (0, ramda_1.nthArg)(1);
const toggle = (property) => !property;
exports.toggle = toggle;
const updateBillingAddress = (propertyName) => (state, property) => (Object.assign(Object.assign({}, state), { billingAddress: Object.assign(Object.assign({}, state.billingAddress), { [propertyName]: property }) }));
exports.updateBillingAddress = updateBillingAddress;
//# sourceMappingURL=index.js.map